export default __webpack_public_path__ + "static/media/fauna-indexes-access-later-draft.35f2ad3a.png";